import { SectionErrorBoundaryProps } from "../SectionErrorBoundary";
import { createContext, ReactNode } from "react";

export type ErrorBoundaryConfig = Omit<SectionErrorBoundaryProps, "children"> & {
	forbiddenFallback?: ReactNode;
	notFoundFallback?: ReactNode;
};

export const ErrorBoundaryContext = createContext<ErrorBoundaryConfig | undefined>(undefined);
